export default "__VITE_ASSET__BUXeuneY__"